export default __webpack_public_path__ + "static/media/Mark-5-Suit-08.812d40f5.jpg";